import { logger } from 'src/helpers/logger';
import { getUnifiedLoginUrl } from 'src/settings';
import { clearLastVisitedRoute } from 'src/helpers/utility';
import { RoleId } from '../../../redux/orgSwitcher/types';

const SAFEGUARD_DISABLED_KEY = 'dfw_switch_org_safeguard_disabled';

interface RedirectParams {
  email: string;
  orgId: string;
  role: RoleId;
}

export const getUnifiedLoginUrlForRole = ({ email, orgId, role }: RedirectParams): string => {
  const params = new URLSearchParams({ email, role_id: role, organization_id: orgId });

  return `${getUnifiedLoginUrl()}/sign-in?${params.toString()}`;
};

export const openUnifiedLogin = ({ email, orgId, role }: RedirectParams): void => {
  window.open(getUnifiedLoginUrlForRole({ email, orgId, role }), '_blank');
};

export const redirectToUnifiedLogin = ({ email, orgId, role }: RedirectParams): void => {
  clearLastVisitedRoute();
  window.location.href = getUnifiedLoginUrlForRole({ email, orgId, role });
};

export const isSafeguardDisabled = (): boolean => {
  try {
    return localStorage.getItem(SAFEGUARD_DISABLED_KEY) === 'true';
  } catch {
    return false;
  }
};

export const disableSafeguard = (): void => {
  try {
    localStorage.setItem(SAFEGUARD_DISABLED_KEY, 'true');
  } catch {
    logger.error('LocalStorage is not available');
  }
};
